const PORTAL_API = {
    // 菜单
    getMenu: "/rest/selfcare/acl/menu/list",
    getWartermark: "/api/watermark/getWartermark/2",
    // 获取logo,公司名
    headerInfo: "/rest/selfcare/indexHeader/get",
    // 获取用户信息接口
    getUserInfo: "/rest/selfcare/findUser",
    // 获取按钮权限
    getBtnPower: "/rest/selfcare/acl/function/list",
    // 获取otp是否开启
    getOtp: "/api/v3/auth/queryAllValid",
    // 获取rsa加密的公钥
    getPublicKey :"/api/v1/secret/getPublicKey",
    // 保存个人偏好语言环境
    savePreferLocale: "/rest/selfcare/savePreferLocale",
    // 设置ticket
    SETTICKET: "/setticket",
    logoutSysetem: "/ngw/tologin", // 拦截401时跳转的路径
    downloadLink: "/apps/rest/update?type=customize&name=", // 插件下载的路径
    orgListEic: "/rest/self/org", // eic-selfcare的通讯录组织列表
    userListEic: "/rest/self/user", // eic-selfcare的通讯录通过组织查询用户列表
    ESSOHost: window.location.protocol === "http:" ? "http://localhost.sso360.cn:57901" : "https://localhost.sso360.cn:57902",

    // *****************我的应用页面***********************
    getApplyList: "/rest/selfcare/apps", // 应用清单
    token: "/rest/selfcare/token", // token
    run: "/run?appkey=",
    profile: "/rest/selfcare/esso/profile",
    account: "/rest/selfcare/esso/account",

    // *****************我的应用页面***********************

    sort: "/rest/selfcare/app/sort",
    // *****************常用链接页面***********************
    /**
     * jilanlan 2021-01-05 11:40
     * desc:  常用链接 新功能接口
     * @params
     **/
    commonLinkAdd: "/rest/selfcare/common-link/add", // 常用链接-新增
    commonLinkList: "/rest/selfcare/common-link/list", // 常用链接-获取
    commonLinkDelete: "/rest/selfcare/common-link/delete", // 常用链接-删除
    commonLinkUpdate: "/rest/selfcare/common-link/update", // 常用链接-修改
    commonLinkPriority: "/rest/selfcare/common-link/priority", // 常用链接-拖拽排序
    // *****************常用链接页面***********************

    // *****************新闻公告页面***********************
    announcementList: "/rest/selfcare/announcement/list", // 公告列表
    announcementDetail: "/rest/selfcare/announcement/get/", // 公告详情
    announcementTypes: "/rest/selfcare/announcement/types/list",// 公告分类
    announcementCarousel: "/rest/selfcare/announcement/carousel/list",// 公告轮播图
    announcementPops: "/rest/selfcare/announcement/pop/list",// 弹窗公告列表
    announcementModule: "/rest/selfcare/announcement/module/list",// 公告模块
    updateAnnouncementModule: "/rest/selfcare/announcement/module/update",// 更新公告模块
    // *****************新闻公告页面***********************

    // *****************访问日志 在线设备页面***********************
    // 访问日志
    accessLogs: "/rest/selfcare/sysloginlog",
    // 获取用户信息
    findUser: "/rest/selfcare/findUser",
    // 在线设备列表
    // onlineDevices: "/cxf/api/v1/ssoSession/queryByUsername",
    onlineDevices: "/cxf/api/v1/ssoSession/querySelfToken",
    // 离线设备
    offLineOthersDevice: "/cxf/api/v1/ssoSession/deleteByTGT",
    // 离线所有设备
    // offLineAllDevice: "/cxf/api/v1/ssoSession/deleteByUsername",
    offLineAllDevice: "/cxf/api/v1/ssoSession/deleteSelfToken",
    // *****************访问日志 在线设备页面***********************

    // *****************个人信息页面***********************
    // 获取动态表单id
    flexiBleForm: "/rest/selfcare/flexibleForm/get",
    // 获取密码策略
    passwordPolicyDefault: "/rest/selfcare/passwordPolicy/default",
    // 获取密码策略
    passwordPolicyLogin: "/rest/selfcare/passwordPolicy/login",
    // 更新密码 密码策略的更新
    changePasswordPasswordPolicy: "/rest/selfcare/changePassword",
    // 获取证书的密码
    CERSERIALNUMBER: "/cer/certificate-user-link/userCerPwd/uid/",
    // 个人证书下载
    PERSONALCER: "/cer/certificate-user-link/uidCer/download/",

    /*-----------esso-----------------*/
    // 新版 esso 里面查询esso是否开启和otp是否开启
    queryAllValid: "/api/v3/auth/queryAllValid",
    originUrl: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : ""), // 兼容IE的origin值
    // originUrl: "http://eicdev53.sso360.cn:10053", // 兼容IE的origin值
    localSetting: "/cxf/api/v3/setting/locale",
    QUERYATAUTH: "/cxf/api/v1/systemConfig/query/at_auth", // 获取跨浏览器是否开启

    /*-----------安全设置--------------*/
    getToken: "/rest/selfcare/token",
    getBindInfo: "/rest/selfcare/security/methods",
    getInternetBindInfo: "/cxf/api/v1/systemConfig/query",
    isBind: "/internet/connect/isbind",
    // 获取是否互联网认证
    internetIsBind: "/internet/connect/isbind",
    internetIsBindAll: "/internet/connect/isbindAll",
    getSystemValid: "/cxf/api/v1/auth/queryAllValid", // 获取系统是否开启
    getSystemBind: "/api/v1/desktop/isbindSystemUserInfo", // 获取是否绑定系统
    getBiolog: "/api/v1/biology/getBiologFixByUserName", // 获取人脸,指纹是否打开,人脸,是否注册信息
    getFinger: "/rest/selfcare/finger", // 获取指纹是否绑定
    bindSystemUserinfo: "/api/v1/desktop/bindSystemUserInfo", // 绑定系统用户
    getQuestions: "/rest/selfcare/security/questions", // 获取问题列表
    internetUnbind: "/internet/connect/unbind",
    appBingUser: "/rest/selfcare/mobileDevice",
    sendValidCode: "/rest/selfcare/security/bindSendMsg", // 发送验证码 绑定
    sendValidCodeUnbind: "/rest/selfcare/security/unbindSendMsg", // 发送验证码 解绑
    messageUnbind: "/rest/selfcare/security/unbind", // 确认解绑
    messageBind: "/rest/selfcare/security/bind", // 确认绑定
    finger: "/rest/selfcare/finger", // 查询或删除指纹
    modifyPassword: "/rest/selfcare/modifyPassword", // 强制修改密码
    faceCheckBind: "/api/v3/face/checkBind", // 普通用户-查询用户是否绑定人脸
    faceBind: "/api/v3/face/bind", // 普通用户-人脸绑定
    faceUnbind: "/api/v3/face/unbind", // 普通用户-人脸解绑
    // 绑定系统用户
    bindSystemUserInfo: "/api/v1/desktop/bindSystemUserInfo",
    // 解绑系统用户
    unbindSystemUserInfo: "/api/v1/desktop/unbindSystemUserInfo",
    // *****************个人信息页面***********************

    // *****************统一代办页面***********************
    sysTypeList: "/rest/selfcare/todo/sysTypeList", // 查询所有待办类型
    modifySysTypeOrder: "/rest/selfcare/todo/modifySysTypeOrder", //调整待办类型tab顺序
    getTodoStatus: "/rest/selfcare/todo/getTodoStatus", //获取待办状态列表
    getTodoTypes: "rest/selfcare/todo/getTodoTypes", //获取待办分类列表
    queryTableColumns: "/rest/selfcare/todo/queryTableColumns", //获取动态表头
    read: "/rest/selfcare/todo/read", //待办已读
    top: "/rest/selfcare/todo/top", //置顶
    todoList: "/rest/selfcare/todo/list", //待办列表查询
    queryUnreadNum: "/rest/selfcare/todo/queryUnreadNum", // 获取某一分类下面的未读数量
    // *****************统一代办页面***********************

    // *****************委托代办页面***********************
    /**
     * 陈夕 2021/3/10 上午11:30
     * desc: 委托代办接口
     **/
    /* 新版本Application */
    apps: "/rest/selfcare/apps",
    deputyApps: "/rest/selfcare/deputy-apps",
    historyConsign: "/rest/selfcare/deputy/history", // 历史委托
    currentConsign: "/rest/selfcare/deputy/app/accountDeputy/list", // 当前委托
    currentConsignDetails: "/rest/selfcare/deputy/idt/deputy/get", // 当前委托详情
    configurationList: "/rest/selfcare/deputy/sys/configuration/list", // 平台参数查询
    userList: "/self/user", // portal 用户接口
    // IDMuserList: "/idt/user/list", // IDM 用户接口
    IDMuserList: "/rest/selfcare/deputy/newDeputyAssignee", // IDM 用户接口
    IDMcommonDeputy: "/rest/selfcare/deputy/commonDeputy", // 获取常用委托人
    IDMcommonDeputyAdd: "/rest/selfcare/deputy/app/accountDeputy/add", // 新增帐号委托
    accountDeputy: "/app/accountDeputy/list", // 当前委托
    accountDeputyDelay: "/rest/selfcare/deputy/app/accountDeputy/delay", // 延期
    accountDeputyRevoke: "/rest/selfcare/deputy/app/accountDeputy/revoke", // 延期
    // *****************委托代办页面***********************

    // 忘记密码页面
    newVerifyImage: "/rest/resetPwd/newVerifyImage",
    checkVerifyImage: "/rest/resetPwd/checkVerifyImage",
    checkExistUserName: "/rest/resetPwd/checkExistUserName",
    sendVerificationCode: "/rest/resetPwd/sendVerificationCode",
    verifyPwd: "/rest/resetPwd/verifyPwd",
    verifyUser: "/rest/resetPwd/verifyUser",
    updatePwd: "/rest/resetPwd/updatePwd",
    generateQrcode: "/api/unify/qrcode/generate", // 生成二维码
    pollingResult: "/api/common/polling/result", // 长轮询接口
    PASSWORDEXPIRED: "/rest/selfcare/passwordPolicy/remind/passwordExpired", // 密码失效时间
    // 新闻公告
    selfcare: {
        announcementList: "/rest/selfcare/announcement/list",
        announcementDetail: "/rest/selfcare/announcement/get/",
        announcementTypes: "/rest/selfcare/announcement/types/list",
        announcementCarousel: "/rest/selfcare/announcement/carousel/list",
        announcementPops: "/rest/selfcare/announcement/pop/list",
        announcementModule: "/rest/selfcare/announcement/module/list",
        updateAnnouncementModule: "/rest/selfcare/announcement/module/update"
    },
    // 应用列表
    changeCode: "/rest/selfcare/app/changeCode",
    // 新版 esso 里面查询esso是否开启和otp是否开启
    /* 个人信息 */
    USERINFO: "/rest/selfcare/findUser",// /rest/selfClient/users/get/user

    // 申请和审批
    myApply: {
        list: "/rest/selfcare/account-apply/list-my-apply",// 列表
        commit: "/rest/selfcare/account-apply/commit",// 提交
        add: "/rest/selfcare/account-apply/add",// 新增
        update: "/rest/selfcare/account-apply/update",// 编辑
        withdraw: "/rest/selfcare/account-apply/withdraw",// 撤回
        detail: "/rest/selfcare/account-apply/",// 详情
        delete: "/rest/selfcare/account-apply/delete",// 删除
        processInstImg: "/rest/selfcare/account-apply/view-process-inst-img/" // 查看流程实例图
    },
    myApprove: {
        list: "/rest/selfcare/account-apply/list-my-task", // 列表
        pass: "/rest/selfcare/account-apply/pass", // 通过
        reject: "/rest/selfcare/account-apply/reject", // 驳回
        assign: "/rest/selfcare/account-apply/assign", // 转办
        delegate: "/rest/selfcare/account-apply/delegate" // 委派
    },
    // 自助流程 工作台
    deskTop: {
        listProcessPermission:"/rest/selfcare/account-apply/list-process-permission", // 查询可申请的流程权限
        processPermissionDetail:"/rest/selfcare/account-apply/process-permission/", // 查询可申请的流程权限
        configuration: "/rest/selfcare/sys/configuration/getValues", // 获取配置信息
        applyPermission: "/rest/selfcare/account-apply/list-apply-permission", // 查询权限信息
        queryDatas: "/report/queryDatas", // 获取图表信息
        getAppPermission: "api/user/portray/appPermission/", // 权限拓扑图
        selfcareApplyPermission: "/rest/selfcare/account-apply/apply-permission/", // 查询权限信息详情
        processInstStatus: "/rest/selfcare/sys/enum-i18-n/get?className=com.paraview.esc.idm.policy.common.enums.ApplyEnum$ProcessInstStatus"
    }
};

// 上下文
const PORTAL_CTX = "portal";
const PORTAL_SSO1_CTX = "esc-sso";
const ESC_SSO = "esc-sso";
const ESC_IDM = "esc-idm";
const Audit_CTX = "common-audit";

const SANITIZE_CONFIG = {
    allowedTags: [
        "address", "article", "aside", "footer", "header", "h1", "h2", "h3", "h4",
        "h5", "h6", "hgroup", "main", "nav", "section", "blockquote", "dd", "div",
        "dl", "dt", "figcaption", "figure", "hr", "li", "main", "ol", "p", "pre",
        "ul", "a", "abbr", "b", "bdi", "bdo", "br", "cite", "code", "data", "dfn",
        "em", "i", "kbd", "mark", "q", "rb", "rp", "rt", "rtc", "ruby", "s", "samp",
        "small", "span", "strong", "sub", "sup", "time", "u", "var", "wbr", "caption",
        "col", "colgroup", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "img","font","strike","input"
    ],
    allowedAttributes: {
        a: ["href", "name", "target"],
        img: ["src", "alt"],
        font:["color", "face", "size"],
        span:['contenteditable'],
        input:["type", "checked", "value"],
        "*":["style", "class"]
    },
    allowedSchemes: ["http", "https", "data"]
}

export {
    PORTAL_API,
    PORTAL_CTX,
    PORTAL_SSO1_CTX,
    ESC_SSO,
    ESC_IDM,
    Audit_CTX,
    SANITIZE_CONFIG
};
